export const MINMAX_FIELD_SELECTOR = "input[type=number]";
export const MINMAX_RANGE_SELECTOR = "input[type=range]";
